import { render, staticRenderFns } from "./img-one.vue?vue&type=template&id=e35b41f0&scoped=true&"
import script from "./img-one.vue?vue&type=script&lang=js&"
export * from "./img-one.vue?vue&type=script&lang=js&"
import style0 from "./img-one.vue?vue&type=style&index=0&id=e35b41f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35b41f0",
  null
  
)

export default component.exports